import { MessagePermission, RolePermission } from "../enums/permissions.enums";
import { NavItem } from "../models/ui/profile-nav-item.model";

export class SplitNavigationPanelConstants {
    public static ORGANIZATION_SETTINGS_NAV_ITEMS = (): NavItem[] => [
    {
        id: 'general',
        label: 'General',
        description: 'Manage general settings.',
        active: true
    },
    {
        id: 'stripe-onboarding',
        label: 'Stripe Onboarding',
        description: 'Configure and manage Stripe payment onboarding settings.',
        active: false
    },
    {
        id: 'transfer-ownership',
        label: 'Organization Ownership',
        description: 'Assign or transfer the organization owner.',
        active: false,
        permission: [RolePermission.OrgOwner]
    },
    {
        id: 'manage-organization-admins',
        label: 'Manage Organization Admins',
        description: 'Add or remove organization administrators.',
        active: false,
        permission: [RolePermission.OrgAdmin]
    },
    {
        id: 'message-suppression',
        label: 'Message Suppression',
        description: 'Suppress outbound messages or redirect emails to a test address.',
        active: false,
        permission: [MessagePermission.ManageSuppressions]
    }
];

    public static USER_SETTINGS_NAV_ITEMS = (): NavItem[] => [
    {
        id: 'payment-methods',
        label: 'Payment Methods',
        description: 'Manage your saved payment methods.',
        active: true
    }
];
}
